export default __webpack_public_path__ + "static/media/notification-empty.44eb1c29.png";